// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p5LgOQ{position:relative;z-index:3;margin-top:9px}.p5LgOQ .h1WaBs{margin-right:20px;color:"color(--linkColor)";text-decoration:underline}.p5LgOQ .h1WaBs.ntKUrR{text-decoration:none;cursor:default}.p5LgOQ .h1WaBs:hover{text-decoration:none;cursor:pointer}.p5LgOQ .vMwRHH{margin-right:20px}.p5LgOQ .o72t_h{display:inline-block;width:9px;height:9px;margin-right:4px}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionButtons": `p5LgOQ`,
	"action": `h1WaBs`,
	"loading": `ntKUrR`,
	"confirmLabel": `vMwRHH`,
	"loader": `o72t_h`
};
export default ___CSS_LOADER_EXPORT___;
